// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2026-07-28T05:59:34Z                      #

// ##############################################################

/**
 * Typ dvoufázového potvrzování.
 */

export const NONE = 'NONE';

export const SMS = 'SMS';

export const EMAIL = 'EMAIL';

/**
 * Seznam všech hodnot.
 */
export const values = [
    NONE,
    SMS,
    EMAIL
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [NONE]: {caption: ''},
    [SMS]: {caption: ''},
    [EMAIL]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}